<app-busqueda></app-busqueda>
<app-burbujas></app-burbujas>
